












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'LargeButton',
})
export default class largeButton extends Vue {

	/* Props
	============================================*/

	/**
	 * Primary label
	 */
	@Prop({type: String, required: true})
	readonly label: string;

	/**
	 * Make display type: block
	 */
	@Prop({type: Boolean, required: false})
	readonly block: boolean;

	/**
	 * Alternative size of the modal. Accepts 'sm, small, lg, or large'
	 */
	@Prop({type: String, required: false, default: 'sm'})
	readonly size: string;
}

